import renderDBN from './dbn_renderer'

export default renderDBN
